module.exports = __webpack_public_path__ + "static/DzemoImac-cb0f40fa5b9f078bcc4ef0f63b33fecb.jpg";